import { useReducer, useCallback, type ReactNode } from 'react';
import { PreviewCtx, previewReducer, EMPTY_PREVIEW, type PreviewContextValue } from '@/stores/previewStore';
import type { PreviewContext } from '@/lib/access-control/types';
import { logAudit } from '@/lib/auditLogger';

export function PreviewProvider({ children }: { children: ReactNode }) {
  const [preview, dispatch] = useReducer(previewReducer, EMPTY_PREVIEW);

  const activatePreview = useCallback((context: PreviewContext, label: string) => {
    dispatch({ type: 'activate', context, label });
    logAudit('preview_activated', 'system', 'preview', {
      newValue: { context, label } as any,
      source: 'admin_ui',
      comment: `Preview mode: ${label}`,
    });
  }, []);

  const deactivatePreview = useCallback(() => {
    dispatch({ type: 'deactivate' });
    logAudit('preview_deactivated', 'system', 'preview', { source: 'admin_ui' });
  }, []);

  const value: PreviewContextValue = { preview, activatePreview, deactivatePreview };

  return <PreviewCtx.Provider value={value}>{children}</PreviewCtx.Provider>;
}
